<template>
  <v-textarea
    color="primary"
    variant="outlined"
  />
</template>